<template>
  <div class="ml-5 mr-5 pb-5">
    <h4 class="titre1 mb-5 mt-4">LANCEMENT DES JEUX DE REQUETES</h4>
    <div class ="container">
    <b-card bg-variant="secondary"
     v-bind:key ="jeuRequete.idJeuRequetes" 
     v-for="jeuRequete in jeuRequetes" class="mb-3 mt-3">
      <ItemAccordion
      :JeuRequetesData="jeuRequete">
      </ItemAccordion>
    </b-card>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import http from '@/http.js'
import ItemAccordion from "@/components/Lancement/itemAccordionLancement.vue"
import eventBus from "@/eventBus";

  export default {
    name: "LancementList",
    components:{
      ItemAccordion,
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setup() {
      const jeuRequetes = ref([]);
      const jeuRequetesData = ref({});

      const getJeux = async () => {
        const data = await http.getJeux();
        jeuRequetes.value = data;
      };

      onMounted(() => {
        getJeux();
        eventBus.on("reloadJeu", getJeux);
      });

      return {
        jeuRequetes,
        jeuRequetesData,
      };
    }
  }
</script>

<style>


.card-body{
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.titres{
  font-size: 20px;
}
.titre1{
  text-align:left !important; 
}

.nav-link1{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #00a3a6;
}
.nav-link1:hover{
  color: black !important;
}

.nav-link2{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #ed6e6c;
}
.nav-link2:hover{
  color: black !important;
}
.nav-link3{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #9dc544;
}
.nav-link3:hover{
  color: black !important;
}
.nav-link4{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #275662;
}
.nav-link4:hover{
  color: black !important;
}
.nav-link5{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #66c1bf;
}
.nav-link5:hover{
  color: black !important;
}
</style>